module.exports = {
    public: {
        companyName: "Thousand Dimensions ( Beijing ) Science and Technology Co., Ltd",
        shareWork: "Share our work and research articles",
    }
}